/**
 * React Query hook for Founder Control Panel dashboard data
 * Exception: Dashboard uses cache (staleTime 60s, gcTime 5min).
 * Query key includes all filters for proper cache isolation.
 */

import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { fetchFounderDashboard } from '../services/dashboardFounderService';
import {
  DASHBOARD_FOUNDER_QUERY_OPTIONS,
  dashboardFounderQueryKey,
} from '../config/queryConfig';
import type { FounderDashboardFilters } from '../types/dashboardFounder';

export function useDashboardFounder(filters: FounderDashboardFilters) {
  return useQuery({
    queryKey: dashboardFounderQueryKey('charts', {
      startDate: filters.startDate,
      endDate: filters.endDate,
      merchantId: filters.merchantId,
      compareWithPrevious: filters.compareWithPrevious,
      city: filters.city,
      zone: filters.zone,
      paymentMethod: filters.paymentMethod,
    }),
    queryFn: () => fetchFounderDashboard(filters),
    ...DASHBOARD_FOUNDER_QUERY_OPTIONS,
    placeholderData: keepPreviousData,
  });
}
